export const useRiverList = () => {
  return useAsyncData('river-list', () => $fetch('/api/river/infolist'))
}
